import {PrintStoryDoc, PrintStoryEvent} from '../types'
import {toMillis} from '../time'

export const mapCallbackLogToEvents = (log: PrintStoryDoc): PrintStoryEvent[] => {
  const ts = toMillis(log.receivedAtMs) || toMillis(log.createdAt)
  if (!ts) {
    return []
  }

  const result = String(log.result || '').toLowerCase()
  const failed = ['failed', 'failure', 'error'].includes(result)

  return [
    {
      ts,
      lane: 'callback',
      laneKey: String(log.jobId || log.deviceId || log.id),
      kind: 'callback_received',
      severity: failed ? 'danger' : 'success',
      deviceId: log.deviceId ? String(log.deviceId) : undefined,
      jobId: log.jobId ? String(log.jobId) : undefined,
      contentId: log.contentId ? String(log.contentId) : undefined,
      codeId: log.codeId ? String(log.codeId) : undefined,
      title: 'Callback log received',
      detail: [log.stage, log.result, log.errorCode].filter(Boolean).join(' · ') || undefined,
      sourceCollection: 'printerCallbackLogs',
      raw: log,
    },
  ]
}

export const mapCallbackLogsToEvents = (logs: PrintStoryDoc[]): PrintStoryEvent[] =>
  logs.flatMap(mapCallbackLogToEvents)
